export default __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-1-02779d3b0334c3e0a85741534eeeef8f.jpg";